<template>
  <div id="app">
    <router-view />
  </div>
</template>


<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden; /* 防止滚动条出现在body上 */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow: auto; /* 允许应用内容滚动 */
  position: relative;
}

/* 页面共用样式 */
.page-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

<script setup>
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  const tokenFromUrl = urlParams.get('token')
  
  if (tokenFromUrl) {
    console.log('[App] 从URL中获取到token，更新状态')
    const userStore = useUserStore()
    userStore.updateToken(tokenFromUrl)
    
    // 清除URL中的token参数
    if (window.history.pushState) {
      const url = new URL(window.location.href)
      url.searchParams.delete('token')
      window.history.replaceState({}, document.title, url.toString())
    }
  }
})
</script>
